
    //获取外网ip方式1：搜狐
    function getIpBysouhu(){
        console.log("---cip---"+returnCitySN["cip"]);
        console.log("---cid---"+returnCitySN["cid"]);
        console.log("---cname---"+returnCitySN["cname"]);
    }
    //获取外网ip方式2：ipify
    function getIpByIpify(callback){
        $.ajax({
            url : "https://api.ipify.org/?format=json&time="+(+new Date()),
            type : "GET",
            data : {},
            dataType : "json",
            success : function(result) {
              console.log("---ip---"+result.ip, window);
              let storeName = 'Global Store', replace_address = 'https://store.chuwi.com';
              let cache_ip = window.localStorage.getItem('Cache-SwitchSite-Ip');
              let cache_country = window.localStorage.getItem('Cache-SwitchSite-Country');
              let cache_countryCode = window.localStorage.getItem('Cache-SwitchSite-Country-Code');
              let cache_countryImg = window.localStorage.getItem('Cache-SwitchSite-Country-Img');
              console.log(cache_ip, cache_country, cache_countryCode, cache_countryImg)
              if(cache_ip && cache_country && cache_ip === result.ip) {
                initStore_name_address(cache_countryCode, storeName, replace_address, (storeName, replace_address) => {
                  console.log(storeName, replace_address)
                  if(window.location.origin != replace_address) {
                    console.log('redirect===>', storeName)
                    callback(cache_country, cache_countryCode, cache_countryImg, replace_address, storeName)
                  }
                })
                
              } else {
                if(result.ip) {
                  window.localStorage.setItem('Cache-SwitchSite-Ip', result.ip);
                  $.ajax({
                    url : "https://api.chuwi.com/getipaddress/index.php?ip=" + result.ip + "&flag=ipwho",
                    type : "GET",
                    success : function(result) {
                      let res = JSON.parse(result)
                      let country = res.country, country_code = res.country_code, country_img = res.flag.img;

                      
                      window.localStorage.setItem('Cache-SwitchSite-Country', country);
                      window.localStorage.setItem('Cache-SwitchSite-Country-Code', country_code);
                      window.localStorage.setItem('Cache-SwitchSite-Country-Img', country_img);
                      console.log("---res---"+ country_code);
                      initStore_name_address(country_code, storeName, replace_address)
                    
                      if(window.location.origin != replace_address) {
                        console.log('redirect===>', storeName)
                        callback(country, country_code, country_img, replace_address, storeName)
                        // window.location = replace_address;
                      }
                    },
                    error : function(){}
                  });
                }
              }
              
            },
            error : function(){}
        });
    }
    function initStore_name_address(country_code, storeName, replace_address, callback) {
      let eu_ips = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'SE'];
      switch(country_code) {
          case 'JP': 
              storeName = 'JP Store'
              replace_address = 'https://store.chuwi.jp'
              break;
          case 'US':
              storeName = 'US Store'
              replace_address = 'https://us.chuwi.com'
              break;
          case 'ES':
              storeName = 'ES Store'
              replace_address = 'https://es.chuwi.com'
              break;
          case 'DE':
              storeName = 'DE Store'
              replace_address = 'https://de.chuwi.com'
              break;
          default:
              if(eu_ips.includes(country_code)) {
                    console.log("includes"+ eu_ips);
                    storeName = 'EU Store'
                    replace_address = 'https://eu.chuwi.com'
              } else {
                    storeName = 'Global Store'
                    console.log("no includes");
              }
              break;
      }
      callback(storeName, replace_address)
    }
    //获取内网ip方式1：
    function getIP() {
        let recode = {};
        let RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
        // 如果不存在则使用一个iframe绕过
        if (!RTCPeerConnection) {
            // 因为这里用到了iframe，所以在调用这个方法的script上必须有一个iframe标签
            // <iframe id="iframe" sandbox="allow-same-origin" style="display:none;"></iframe>
            let win = iframe.contentWindow;
            RTCPeerConnection = win.RTCPeerConnection || win.mozRTCPeerConnection || win.webkitRTCPeerConnection;
        }
 
        //创建实例，生成连接
        let pc = new RTCPeerConnection();
 
        // 匹配字符串中符合ip地址的字段
        function handleCandidate(candidate) {
            let ip_regexp = /([0-9]{1,3}(\.[0-9]{1,3}){3}|([a-f0-9]{1,4}((:[a-f0-9]{1,4}){7}|:+[a-f0-9]{1,4}){6}))/;
            let ip_isMatch = candidate.match(ip_regexp)[1];
            console.log("---ip(内)---"+ip_isMatch);
            if (!recode[ip_isMatch]) {
                recode[ip_isMatch] = true;
            }
        }
 
        //监听icecandidate事件
        pc.onicecandidate = (ice) => {
            if (ice.candidate) {
                handleCandidate(ice.candidate.candidate);
            }
        };
        //建立一个伪数据的通道
        pc.createDataChannel('');
        pc.createOffer((res) => {
            pc.setLocalDescription(res);
        }, () => {});
 
        //延迟，让一切都能完成
        setTimeout(() => {
            let lines = pc.localDescription.sdp.split('\n');
            lines.forEach(item => {
                if (item.indexOf('a=candidate:') === 0) {
                    handleCandidate(item);
                }
            })
        }, 1000);
    }